import { render, staticRenderFns } from "./WaiterEdit.vue?vue&type=template&id=33153a75&scoped=true&lang=pug"
import script from "./WaiterEdit.vue?vue&type=script&lang=ts"
export * from "./WaiterEdit.vue?vue&type=script&lang=ts"
import style0 from "./WaiterEdit.vue?vue&type=style&index=0&id=33153a75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33153a75",
  null
  
)

export default component.exports